//@flow
import * as React from 'react';
import * as Immutable from 'immutable';
import { themr } from 'react-css-themr';
import addressListFactory from 'common/components/common/AddressList';
import BulkLocationCardContainer from 'common/entity/locationMaster/BulkLocationCardContainer';
import { IconTab, IconTabs } from 'common/components/core/tabs';
import defaultTheme from './TabbedBulkAddressList.scss';
import { GroupedGeocodeEditLocation } from 'common/models/internal/GroupedGeocodeEditLocation';
import { GeocodeEditLocation } from 'common/models/internal/GeocodeEditLocation';
import GroupedAddressList from 'common/entity/locationMaster/GroupedAddressList';
const BulkAddressListComponent = addressListFactory({
    CardComponent: BulkLocationCardContainer
});

type Props = {
    theme: Object,
    groupBy: ?string,
    groupedLocations: Immutable.List<GroupedGeocodeEditLocation>,
    locations: Immutable.List<GeocodeEditLocation>,
    groupPositionInList?: number,
    expandedGroupId: ?string,
    expandedLocationId: ?string,
    selectedLocationId: ?string,
    currentTab: string,
    searchText: string,
    handleLatLngClick: Function,
    handleClearSearchText: Function,
    handleSearchTextChange: (searchText: string) => void,
    handleTabChange: (currentTab: string) => void,
    handleAddressChange: ({
        locationEntity: GroupedGeocodeEditLocation | GeocodeEditLocation,
        latLng: { lat: string, lng: string }
    }) => void,
    handleGroupVerify: ({ locationEntity: GroupedGeocodeEditLocation }) => void,
    handleVerify: ({ locationEntity: GeocodeEditLocation }) => void,
    handleGroupCardClick: ({
        locationEntity: GroupedGeocodeEditLocation
    }) => void,
    handleCardClick: ({ locationEntity: GeocodeEditLocation }) => void,
    handleResetLocation: ({ locationEntity: GeocodeEditLocation }) => void,
    handleResetGroupLocations: ({
        locationEntity: GroupedGeocodeEditLocation
    }) => void
};

const AddressTabsEnum = {
    Individual: 'INDIVIDUAL',
    Grouped: 'GROUPED'
};

class TabbedBulkAddressList extends React.PureComponent<Props> {
    tabs = [AddressTabsEnum.Individual, AddressTabsEnum.Grouped];
    handleTabChange = index => {
        const { handleTabChange } = this.props;
        handleTabChange && handleTabChange(this.tabs[index]);
    };

    renderList = () => {
        return <BulkAddressListComponent {...this.props} filterAddress />;
    };

    renderTabbedList = () => {
        const {
            groupedLocations,
            locations,
            handleAddressChange,
            handleGroupVerify,
            handleVerify,
            handleGroupCardClick,
            expandedGroupId,
            handleCardClick,
            theme,
            groupPositionInList,
            expandedLocationId,
            selectedLocationId,
            handleResetLocation,
            handleResetGroupLocations,
            currentTab,
            searchText,
            handleLatLngClick,
            handleSearchTextChange,
            handleClearSearchText,
            getRadiusAndCenter
        } = this.props;

        return (
            <IconTabs
                theme={theme}
                index={this.tabs.indexOf(currentTab)}
                onChange={this.handleTabChange}
            >
                <IconTab
                    theme={theme}
                    label={AddressTabsEnum.Individual}
                    rightIcon={locations && locations.size}
                >
                    {this.renderList()}
                </IconTab>
                <IconTab
                    label={AddressTabsEnum.Grouped}
                    rightIcon={groupedLocations.size}
                >
                    <GroupedAddressList
                        expandedLocationId={expandedLocationId}
                        selectedLocationId={selectedLocationId}
                        expandedGroupId={expandedGroupId}
                        handleCardClick={handleCardClick}
                        handleVerify={handleVerify}
                        handleAddressChange={handleAddressChange}
                        handleResetGroupLocations={handleResetGroupLocations}
                        handleResetSingleLocation={handleResetLocation}
                        handleGroupVerify={handleGroupVerify}
                        handleGroupCardClick={handleGroupCardClick}
                        locations={groupedLocations}
                        positionInSortedList={groupPositionInList}
                        handleLatLngClick={handleLatLngClick}
                        handleSearchTextChange={handleSearchTextChange}
                        handleClearSearchText={handleClearSearchText}
                        searchText={searchText}
                        theme={theme}
                        getRadiusAndCenter={getRadiusAndCenter}
                    />
                </IconTab>
            </IconTabs>
        );
    };
    render() {
        const { groupBy, groupedLocations } = this.props;
        if (!groupBy || !groupedLocations) {
            return this.renderList();
        } else {
            return this.renderTabbedList();
        }
    }
}
export default themr('BulkAddressList', defaultTheme)(TabbedBulkAddressList);
